import { useBundle } from '@amzn/react-arb-tools';
import { useCallback } from 'react';
import messages from 'src/i18n/translations/star-grid.json';

const fallback = messages.en['pages.starGrid'];
export type DataSyncTextKey = keyof typeof fallback;
export type DataSyncText = (key: DataSyncTextKey) => string;

export function useDataSyncText(): DataSyncText {
  const [bundle] = useBundle('pages.starGrid');
  return useCallback(
    (key: DataSyncTextKey): string => {
      try {
        return bundle?.getMessage(key) ?? fallback[key];
      } catch {
        return fallback[key];
      }
    },
    [bundle]
  );
}
